const store = new Map()

export const FIVE_MINUTES_MS = 5 * 60 * 1000
export const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000

export function makeKey (url, params) {
  return `${url}?${JSON.stringify(params || {})}`
}

export async function cached (key, fetcher, ttlMs = TWELVE_HOURS_MS) {
  const entry = store.get(key)
  const now = Date.now()

  if (entry && now - entry.timestamp < ttlMs) return entry.value

  const value = await fetcher()
  store.set(key, { value, timestamp: now })
  return value
}

export function invalidate (prefix) {
  for (const k of store.keys()) {
    if (k.startsWith(prefix)) store.delete(k)
  }
}

export function clearCache () {
  store.clear()
}
